import { Subject } from 'rxjs';

export interface Toast {
    message: string;
    type: 'success' | 'error' | 'warning';
}

export const toastSubject = new Subject<Toast | null>();
